export const nextDay = (date: Date) => new Date(date.setDate(date.getDate() + 1));
export const previousDay = (date: Date) => new Date(date.setDate(date.getDate() - 1));
